export default class MathUtil {
    /**
     * 
     * @param x 
     * @param y 
     * @param ax 
     * @param ay 
     * @param bx 
     * @param by 
     * 
     * @returns 
     */
    pointLineDistSq(x: number, y: number, ax: number, ay: number, bx: number, by: number): number {
        var abLengthSq = this.distSq(ax, ay, bx, by); // Return minimum distance between line segment ab and point p
        
        if (!abLengthSq) {
            return this.distSq(ax, ay, x, y);
        }
        
        // Consider the line extending the segment, parameterized as a + c (b - a).
        // We find projection of this point onto the line. 
        // It falls where c = [(p-a) . (b-a)] / |b-a|^2
        var c = ((x - ax) * (bx - ax) + (y - ay) * (by - ay)) / abLengthSq;
        var pabx = ax + c * (bx - ax);
        var paby = ay + c * (by - ay);
        return this.distSq(x, y, pabx, paby);
    }
    
    /**
     * 
     * @param ax 
     * @param ay 
     * @param bx 
     * @param by 
     * 
     * @returns 
     */
    distSq(ax: number, ay: number, bx: number, by: number): number {
        var dx = bx - ax;
        var dy = by - ay;
        return (dx * dx) + (dy * dy);
    }
}
